module.exports = __webpack_public_path__ + "testerstatic/media/psymetrics-logo-horizontal-black.67bdf754.svg";